angular.module('ui.slimscroll', []).directive('slimscroll', function () {
  'use strict';

  return {
    restrict: 'A',
    link: function ($scope, $elem, $attr) {
      var off = [];
      var option = {};

      var refresh = function () {
        if (angular.isDefined($attr.slimscroll)) {
          option = $scope.$eval($attr.slimscroll) || {};
        } else if ($attr.slimscrollOption) {
          option = $scope.$eval($attr.slimscrollOption) || {};
        }

        var el = angular.element($elem);

        el.slimScroll({destroy: true});
        el.slimScroll(option);
      };

      var registerWatch = function () {
        if (angular.isDefined($attr.slimscroll) && !option.noWatch) {
          off.push($scope.$watchCollection($attr.slimscroll, refresh));
        }

        if ($attr.slimscrollWatch) {
          off.push($scope.$watchCollection($attr.slimscrollWatch, refresh));
        }

        if ($attr.slimscrolllistento) {
          off.push($scope.$on($attr.slimscrolllistento, refresh));
        }
      };

      var destructor = function () {
        angular.element($elem).slimScroll({destroy: true});
        off.forEach(function (unbind) {
          unbind();
        });
        off = null;
      };

      off.push($scope.$on('$destroy', destructor));

      registerWatch();
    }
  };
});


// in case of update slimscroll directive please update the above
// below I extend slimscroll directive with decorator

// unfortunately I cannot use it as it would add inherited scope=true to ALL scrolled content which is not sensible
(function() {
    'use strict';
/*
angular.module('ui.slimscroll').config(['$provide', function($provide) {
    $provide.decorator('slimscrollDirective', ['$delegate', '$timeout', '$compile', function($delegate, $timeout, $compile) {
        var directive = $delegate[0];
        var link = directive.link;

        // console.log(directive);

        // we extend directive compile function // to test - what happens if there's compile bit?
        directive.scope = true;
        directive.compile = function() {
            return function(scope, element, attrs) {
                link.apply(this, arguments);

    // the code starts here

    if( angular.isDefined(attrs.expandFullHeight) ) {

        // we have to unfortunately watch height as when the element is loaded to the hidden tab the height is 0,
        // so we wouldn't know whether to place the expand link below
        // (potential performance problem)
        var unwatch = scope.$watch(
            function(){
                return element.outerHeight();
            },
            function(newVal,oldVal){
                if(newVal != 0){
                    registerExpandFullHeight();
                    unwatch();
                }
            }
        );

        function registerExpandFullHeight(){
            scope.expanded = false;

            var cssHeight = element.css('max-height');
            var height = {
                max: cssHeight == 'none' ? 0 : parseFloat(cssHeight),
                outer: element.outerHeight()
            }

            if(height.outer >= height.max){
                $timeout(function(){

                    element.parent().after( $compile('<div class="clearfix" style="display:block;" ng-show="!expanded"><a style="float:right;" href="javascript:void(0);" ng-click="heightSwitch();"><small>Expand to full height</small></a></div>')(scope) );
                    element.parent().after( $compile('<div class="clearfix" style="display:block;" ng-show="expanded"><a style="float:right;" href="javascript:void(0);" ng-click="heightSwitch();"><small>Collapse</small></a></div>')(scope) );

                    scope.heightSwitch = function(){
                        if(!scope.expanded){
                            element.addClass('full-height');
                            element.closest('.slimScrollDiv').css('height', 'auto!important').addClass('full-height');
                        } else {
                            element.removeClass('full-height');
                            element.closest('.slimScrollDiv').css('height', 'auto!important').removeClass('full-height');
                        }
                        scope.expanded = !scope.expanded;
                    }
                });
            }

        }
    }

    // code ends


            };
        };

        return $delegate;
    }]);
}]);
*/

/* original directive */

/**
@ngdoc directive
@name expandFullHeight

@description
For slimscroll - ads the link expanding the container to full height (accessibility requirement for Dragon users).

*/
function expandFullHeight($compile, $timeout) {
    return {
        scope: true,
        restrict: 'A',
        link: function(scope, element, attrs) {

            if( !angular.isDefined(attrs.slimscroll) ) {
                console.warning('This directive can be only applied for slimscroll.');
                return;
            }

            scope.expanded = false;

            // we have to unfortunately watch height as when the element is loaded to the hidden tab the height is 0,
            // so we wouldn't know whether to place the expand link below
            // (potential performance problem)
            var unwatch = scope.$watch(
                function(){
                    return element.outerHeight();
                },
                function(newVal,oldVal){
                    if(newVal != 0){
                        registerExpandFullHeight();
                        unwatch();
                    }
                }
            );

            function registerExpandFullHeight(){

                var cssHeight = element.css('max-height');
                var height = {
                    max: cssHeight == 'none' ? 0 : parseFloat(cssHeight),
                    outer: element.outerHeight()
                }

                $timeout(function(){
                    if(height.outer >= height.max){

                        element.parent().removeClass('full-height-switch-hidden');
                        element.parent().after($compile( [
                            '<div class="full-height-link expand clearfix">',
                                '<a href="javascript:void(0);" ng-click="heightSwitch();" title="Expand/collapse full height">',
                                    '<small ng-show="!expanded">full height</small>',
                                    '<small ng-show="expanded">collapse</small>',
                                '</a>',
                            '</div>'].join("") )(scope));

                        scope.heightSwitch = function(){
                            if(!scope.expanded){
                                element.addClass('full-height');
                                element.closest('.slimScrollDiv').css('height', 'auto!important').addClass('full-height');
                            } else {
                                element.removeClass('full-height');
                                element.closest('.slimScrollDiv').css('height', 'auto!important').removeClass('full-height');
                            }
                            scope.expanded = !scope.expanded;
                        }
                    } else {
                        element.parent().addClass('full-height-switch-hidden');
                    }
                });
            }
        }
    };
}
expandFullHeight.$inject = ['$compile', '$timeout'];
angular.module('app').directive('expandFullHeight', expandFullHeight);


}());